export default __webpack_public_path__ + "static/media/btn_step_1_default.6ffbc91d.svg";